"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchClickAndCollectDeliveryOptionsPath = exports.searchClickAndCollectDeliveryOptions = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const searchClickAndCollectDeliveryOptions = (client) => async ({ checkoutId, consignmentId, logisticOfferId }) => {
    try {
        const response = await client.post((0, exports.searchClickAndCollectDeliveryOptionsPath)(checkoutId, consignmentId), {
            logisticOfferId
        });
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.searchClickAndCollectDeliveryOptions = searchClickAndCollectDeliveryOptions;
const searchClickAndCollectDeliveryOptionsPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/click-and-collect-options/search`;
exports.searchClickAndCollectDeliveryOptionsPath = searchClickAndCollectDeliveryOptionsPath;
